import { render, staticRenderFns } from "./goodsFilter.vue?vue&type=template&id=199b9a72&scoped=true"
import script from "./goodsFilter.vue?vue&type=script&lang=js"
export * from "./goodsFilter.vue?vue&type=script&lang=js"
import style0 from "./goodsFilter.vue?vue&type=style&index=0&id=199b9a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b9a72",
  null
  
)

export default component.exports